<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  text: string
}>()

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <Button
    v-tooltip.top="text"
    type="button"
    icon="pi pi-question-circle"
    text
    rounded
    size="small"
    :aria-label="t('pageTitleHelp.label')" />
</template>

<i18n lang="json">
{
  "de": {
    "pageTitleHelp": {
      "label": "Weitere Informationen"
    }
  },
  "en": {
    "pageTitleHelp": {
      "label": "More information"
    }
  }
}
</i18n>
